// extracted by mini-css-extract-plugin
module.exports = {"price":"OD-z","onSale":"PD-z"};